export interface iAccountIcon {
    isActive?: boolean;
}

export const Account = (props: iAccountIcon) => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3 18V21H21V18C21 15.7909 19.2091 14 17 14H7C4.79086 14 3 15.7909 3 18Z" fill={props.isActive ? "#1F1F1F" : "white"} stroke={props.isActive ? "#1F1F1F" : "#808080"} strokeWidth="2"/>
            <circle cx="12" cy="7" r="4" fill={props.isActive ? "#1F1F1F" : "none"} stroke={props.isActive ? "#1F1F1F" : "#808080"} strokeWidth="2"/>
        </svg>
    );
  };
  
  